import {
  CreateItemRequest,
  ItemBestSellerModel,
  ItemModel,
  ToppingModel,
} from "../../../infrastructure/model/ProductItemModel";
import { ItemService } from "../../../infrastructure/services/ItemService";
import HttpUtils from "../../utils/HttpUtils";
import { BaseCommonApiUseCaseDeps } from "./CommonApiUseCase";

export const getAllItemsUseCase = async (deps: BaseCommonApiUseCaseDeps): Promise<ItemModel[]> => {
  const { setLoading, showError } = deps;
  try {
    setLoading?.(true);
    let dataMapper: ItemModel[] = [];
    const res = await ItemService.getAllItem();
    HttpUtils.handleResponse(res, {
      onDefaultError() {
        showError?.(res.message);
      },
      onSuccessWithData(res) {
        dataMapper = res.data;
      },
    });
    return dataMapper;
  } finally {
    setLoading?.(false);
  }
};

export const getItemBestSellerUseCase = async (
  deps: BaseCommonApiUseCaseDeps
): Promise<ItemBestSellerModel[]> => {
  const { setLoading, showError } = deps;
  try {
    setLoading?.(true);
    let dataMapper: ItemBestSellerModel[] = [];
    const res = await ItemService.getItemsBestSeller();
    HttpUtils.handleResponse(res, {
      onDefaultError() {
        showError?.(res.message);
      },
      onSuccessWithData(res) {
        dataMapper = res.data;
      },
    });
    return dataMapper;
  } finally {
    setLoading?.(false);
  }
};

export const getAllToppingUseCase = async (
  deps: BaseCommonApiUseCaseDeps
): Promise<ToppingModel[]> => {
  const { setLoading, showError } = deps;
  try {
    setLoading?.(true);
    let dataMapper: ToppingModel[] = [];
    const res = await ItemService.getAllTopping();
    HttpUtils.handleResponse(res, {
      onDefaultError() {
        showError?.(res.message);
      },
      onSuccessWithData(res) {
        dataMapper = res.data;
      },
    });
    return dataMapper;
  } finally {
    setLoading?.(false);
  }
};

export const createItemUseCase = async (
  deps: BaseCommonApiUseCaseDeps & { request: CreateItemRequest; imageFile?: File }
): Promise<ItemModel | undefined> => {
  const { request, imageFile, setLoading, showError, showSuccess } = deps;
  try {
    setLoading?.(true);
    let dataMapper: ItemModel | undefined = undefined;
    const res = await ItemService.createNewItem(request, imageFile);
    HttpUtils.handleResponse(res, {
      onDefaultError() {
        showError?.(res.message);
      },
      onSuccessWithData(res) {
        showSuccess?.();
        dataMapper = res.data;
      },
    });
    return dataMapper;
  } finally {
    setLoading?.(false);
  }
};

export const updateItemUseCase = async (
  deps: BaseCommonApiUseCaseDeps & { request: CreateItemRequest & { id: number; imageFile?: File } }
): Promise<ItemModel | undefined> => {
  const { request, setLoading, showError, showSuccess } = deps;
  try {
    setLoading?.(true);
    let dataMapper: ItemModel | undefined = undefined;
    const res = await ItemService.updateItem(request);
    HttpUtils.handleResponse(res, {
      onDefaultError() {
        showError?.(res.message);
      },
      onSuccessWithData(res) {
        showSuccess?.();
        dataMapper = res.data;
      },
    });
    return dataMapper;
  } finally {
    setLoading?.(false);
  }
};

export const createToppingUseCase = async (
  deps: BaseCommonApiUseCaseDeps & { request: Omit<ToppingModel, "id"> }
): Promise<ToppingModel | undefined> => {
  const { request, setLoading, showError, showSuccess } = deps;
  try {
    setLoading?.(true);
    let dataMapper: ToppingModel | undefined = undefined;
    const res = await ItemService.createNewTopping(request);
    HttpUtils.handleResponse(res, {
      onDefaultError() {
        showError?.(res.message);
      },
      onSuccessWithData(res) {
        showSuccess?.();
        dataMapper = res.data;
      },
    });
    return dataMapper;
  } finally {
    setLoading?.(false);
  }
};

export const updateToppingUseCase = async (
  deps: BaseCommonApiUseCaseDeps & { request: ToppingModel }
): Promise<ToppingModel | undefined> => {
  const { request, setLoading, showError, showSuccess } = deps;
  try {
    setLoading?.(true);
    let dataMapper: ToppingModel | undefined = undefined;
    const res = await ItemService.updateTopping(request);
    HttpUtils.handleResponse(res, {
      onDefaultError() {
        showError?.(res.message);
      },
      onSuccessWithData(res) {
        showSuccess?.();
        dataMapper = res.data;
      },
    });
    return dataMapper;
  } finally {
    setLoading?.(false);
  }
};

export const deleteToppingUseCase = async (
  deps: BaseCommonApiUseCaseDeps & { toppingId: number }
): Promise<boolean> => {
  const { toppingId, setLoading, showError, showSuccess } = deps;
  try {
    setLoading?.(true);
    let dataMapper = false;
    const res = await ItemService.deleteTopping(toppingId);
    HttpUtils.handleResponse(res, {
      onDefaultError() {
        showError?.(res.message);
      },
      onSuccess() {
        showSuccess?.("Xoá topping thành công");
        dataMapper = true;
      },
    });
    return dataMapper;
  } finally {
    setLoading?.(false);
  }
};

export const deleteItemUseCase = async (
  deps: BaseCommonApiUseCaseDeps & { itemId: number }
): Promise<boolean> => {
  const { itemId, setLoading, showError, showSuccess } = deps;
  try {
    setLoading?.(true);
    let dataMapper = false;
    const res = await ItemService.deleteItem(itemId);
    HttpUtils.handleResponse(res, {
      onDefaultError() {
        showError?.(res.message);
      },
      onSuccess() {
        showSuccess?.("Xoá item thành công");
        dataMapper = true;
      },
    });
    return dataMapper;
  } finally {
    setLoading?.(false);
  }
};
